/**
 * Regime mapping helpers used to convert regime labels
 * between frontend display format and backend enum format.
 *
 * Examples:
 * - MDA-AGESSA <-> MDA_AGESSA
 * - CARCDSF Sage-femme <-> CARCDSF_SAGE_FEMME
 */

import { compose, defaultTo, find, head, ifElse, isNil, toPairs } from 'ramda';

const REGIME_MAPPING = {
  'MDA-AGESSA': 'MDA_AGESSA',
  'CARCDSF Sage-femme': 'CARCDSF_SAGE_FEMME',
  'CARCDSF dentiste': 'CARCDSF_DENTSTE'
};

export const formattedRegime = (regime) =>
  REGIME_MAPPING[regime] || regime;

export const unformattedRegime = (regime) =>
  compose(
    defaultTo(regime),
    ifElse(isNil, defaultTo(regime), head),
    find(([, value]) => value === regime),
    toPairs
  )(REGIME_MAPPING);
